
import { Link } from "react-router-dom";
import { LeftProps } from "../../../assets/icons";

export default function Breadcrumb({ linkDataList }) {
	return (
		<div className="bg-white w-full p-[10px]">
			<nav className="flex items-center text-sm font-Vazir-300" aria-label="breadcrumb">
				{linkDataList.map((linkData, index) => (
					<div key={index} className="flex items-center">
						{index > 0 && <span className="mx-2">
							<LeftProps stroke="#969BA1" height="10px" width="5px" />
						</span>}
						{linkData.href ? (
							<Link
								to={linkData.href}
								className="font-Vazir-300 text-[#969BA1] text-[12px]"
							>
								{linkData.label}
							</Link>
						) : (
							<span className="font-Vazir-500 text-[#969BA1] text-[12px]">{linkData.label}</span>
						)}
					</div>
				))}
			</nav>
		</div>
	);
};
